module.exports = __webpack_public_path__ + "static/008153-bcc46fc5b92c30bcffc64b4f14c12f9e.jpg";